import {BrowserRouter} from 'react-router';
import Main from './pages/Main.tsx';

function App() {
    return (
        <BrowserRouter>
            <Main />
        </BrowserRouter>
    );
}

export default App;
